// src/pages/RoadmapRow.js
import React from "react";


export default function PfRoadmap_rows({ 
  index, 
  data, 
  onChange, 
  onRemove, 
  onOpenBudget, 
  onOpenValuation, 
  onOpenFunding   // ✅ add this
}) 

{
    return (

    <tr>
      <td>{index + 1}</td>
      <td>
        <select
    className="w3-select w3-border"
    value={data.fy}
    onChange={(e) => onChange(index, "fy", e.target.value)}
  >
    <option value="">-- Select FY --</option>
    <option value="FY2025">FY2025</option>
    <option value="FY2026">FY2026</option>
    <option value="FY2027">FY2027</option>
    <option value="FY2028">FY2028</option>
    <option value="FY2029">FY2029</option>
    <option value="FY2030">FY2030</option>
    <option value="FY2031">FY2031</option>
    <option value="FY2032">FY2032</option>
    <option value="FY2033">FY2033</option>
    <option value="FY2034">FY2034</option>
    <option value="FY2035">FY2035</option>
  </select>
      </td>
      <td>
        <select
          value={data.stage || ""}
          onChange={(e) => onChange(index, "stage", e.target.value)}
          className="w3-select w3-border"
        >
          <option value="">-- Select Stage --</option>
          <option value="Pre-Seed">Pre-Sead</option>
          <option value="Seed">Seed</option>
          <option value="MVP">MVP</option>
          <option value="GTM">GTM</option>

          <option value="Expansion">Expansion</option>
          <option value="Growth">Growth</option>
          <option value="Maturity">Maturity</option>
        </select>
      </td>
      
      <td>
        <input
          type="text"
          value={data.activity}
          onChange={(e) => onChange(index, "activity", e.target.value)}
          className="w3-input w3-border"
        />
      </td>
      <td>
        <input
          type="number"
          value={data.budget || 0}
          readOnly
          className="w3-input w3-border w3-light-blue w3-text-indigo w3-cursor"
          style={{cursor:"pointer"}}
          onClick={onOpenBudget}
          title="Click to open budget calculator"
        />
      </td>

       <td className="w3-hide">
        <input
          type="number"
          value={data.valuation || 0}
          readOnly
          className="w3-input w3-border"
          onClick={onOpenValuation}
          title="Click to open valuation calculator"
        />
      </td>

<td className="w3-hide">
  <input
    type="number"
    value={data.funding || 0}
    readOnly
    className="w3-input w3-border"
    onClick={onOpenFunding}
    title="Click to open funding popup"
  />
</td>



      <td>
        <button className="w3-button w3-red" onClick={() => onRemove(index)}>✕</button>
      </td>
    </tr>
  );
}
